//third party
import { NgModule } from '@angular/core';

//pipes
import { GraphQLComparisionAsStringPipe } from './graphQLComparisionAsStringPipe.pipe';



import { TelepoCdrTypePipe } from './telepoCdrType.pipe';
import { TelepoCdrResultPipe } from './telepoCdrResult.pipe';
import { BillingIdToOwnerTypePipe } from './billingIdToOwnerType.pipe';
import { TelepoCdrResultColorPipe } from './telepoCdrResultColor.pipe';
import { TelepoCdrApTypePipe_Icon } from './telepoCdrApType_Icon.pipe';
import { TelepoCdrApTypePipe_Name } from './telepoCdrApType_Name.pipe';
import { MosResultColorPipe } from './mosResultColor.pipe';
import { TelepoCdrDiversionReason } from './telepoCdrDiversionReason.pipe';


import { OwnerTypeIdToStringPipe } from './ownerTypeIdToString.pipe';
import { SecondsToTimeSpan } from './secondsToTimeSpan.pipe';






@NgModule({
  exports: [
    GraphQLComparisionAsStringPipe,
    
    TelepoCdrTypePipe,
    TelepoCdrResultPipe,
    BillingIdToOwnerTypePipe,
    OwnerTypeIdToStringPipe,
    SecondsToTimeSpan,
    TelepoCdrResultColorPipe,
    TelepoCdrApTypePipe_Icon,
    TelepoCdrApTypePipe_Name,
    MosResultColorPipe,
    TelepoCdrDiversionReason,
    
  ],
  declarations: [
    GraphQLComparisionAsStringPipe,
    TelepoCdrTypePipe,
    TelepoCdrResultPipe,
    BillingIdToOwnerTypePipe,
    OwnerTypeIdToStringPipe,
    SecondsToTimeSpan,
    TelepoCdrResultColorPipe,
    TelepoCdrApTypePipe_Icon,
    TelepoCdrApTypePipe_Name,
    MosResultColorPipe,
    TelepoCdrDiversionReason,
   
    
  ],
  imports: [
    
  ]
})
export class PipesModule { }
